import React, { useEffect, useState } from "react";
import {
  Grid,
  Tabs,
  Tab,
  Typography,
  Box,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import _ from "lodash";

import WithLoading from "../../../../utils/WithLoading";
import CreateNewNode from "./CreateNewNode";
import BannersInfoNode from "./BannersInfoNode";
import { NODE_STATUS_CREATE } from "../../../../utils/consts";
import CardCommon from "../../../../components/card/CardCommon";

export interface BannerTypesProps {
  nodes: any;
  getThemeInfo: any;
  isLoading: boolean;
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    discountTypeSection: {
      borderRadius: 8,
    },
    tabPanel: {
      backgroundColor: theme.palette.background.default,
    },
  }),
);

interface TabPanelProps {
  children: React.ReactNode;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      className={classes.tabPanel}
      hidden={value !== index}
      id={`discount-type-tab-${index}`}
      aria-labelledby={`discount-type-tab-${index}`}
      {...other}
    >
      {value === index && <div style={{ padding: "16px 0" }}>{children}</div>}
    </div>
  );
};

const BannersType: React.FunctionComponent<BannerTypesProps> = ({
  nodes,
  getThemeInfo,
  isLoading,
}) => {
  const [bannerNodes, setBannerNodes] = useState<any[]>([]);
  const [themeInitialNodes, setThemeInitialNodes] = useState<any>({});
  const [paymentInlineNodes, setPaymentInlineNodes] = useState<any[]>([]);
  const [storePopupNodes, setStorePopupNodes] = useState<any[]>([]);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setThemeInitialNodes(nodes);
  }, [nodes]);

useEffect(() => {
  setBannerNodes(themeInitialNodes.banners || []);

  const paymentInlineNodes =
    themeInitialNodes?.banners
      ?.map((node: any, idx: number) => ({ ...node, index: idx }))
      .filter((node: any) => node.bannerType === "PAYMENT_INLINE") || [];

  const storePopupNodes =
    themeInitialNodes?.banners
      ?.map((node: any, idx: number) => ({ ...node, index: idx }))
      .filter((node: any) => node.bannerType === "STORE_POPUP") || [];

  setPaymentInlineNodes(paymentInlineNodes);
  setStorePopupNodes(storePopupNodes);
}, [themeInitialNodes]);

  const createNode = (nodeData: any) => {
    // const clone = _.cloneDeep(themeInitialNodes.banners);
    // clone.push(nodeData)
    const cloneThemeInitialNodes = _.cloneDeep(themeInitialNodes);
    // cloneThemeInitialNodes.banners = cloneThemeInitialNodes
    cloneThemeInitialNodes.banners.push(nodeData)
  //  const clone =  themeInitialNodes.banners.push(nodeData)

    setThemeInitialNodes(cloneThemeInitialNodes);
  };

  const handleCreateNode = () => {
    const nodeData = {
      status: "create",
      availability: [],
      isActive: true,
      title: "",
      backgroundColor: "#ffffff",
      deliveryTypes: [],
      subtitle: "",
      textColor: "",
      paymentTypes: [],
      bannerType: tabValue === 0 ? "STORE_POPUP" : "PAYMENT_INLINE",
    };
    createNode(nodeData);
  };

  const handleRemoveNode = () => {
    const clone = _.cloneDeep(themeInitialNodes);
   const filter = clone.banners.filter((node: any) => node.status !== NODE_STATUS_CREATE)
   clone.banners=filter
   setThemeInitialNodes(clone)
    setBannerNodes(
      bannerNodes.filter((node: any) => node.status !== NODE_STATUS_CREATE),
    );
  };

  const classes = useStyles();

  return (
    <>
      <CardCommon>
        <Tabs
          centered
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}
          aria-label="discount-types-tabs"
          variant="fullWidth"
        >
          <Tab
            label="STORE POPUP"
            id="discount-type-tab-0"
            aria-controls="discount-type-tab-0"
          />
          <Tab
            label="PAYMENT INLINE"
            id="discount-type-tab-1"
            aria-controls="discount-type-tab-1"
          />
        </Tabs>
      </CardCommon>

      <div className={classes.root}>
        <TabPanel value={tabValue} index={0}>
          <Grid container spacing={2}>
            {storePopupNodes?.map((nodeData: any) => (
              <Grid
                item
                sm={12}
                md={6}
                xs={12}
                lg={4}
                key={nodeData.id || nodeData.index}
                style={{ display: "flex" }}
              >
                <BannersInfoNode
                  nodeData={nodeData}
                  index={nodeData.index}
                  themeInitialNodes={themeInitialNodes}
                  getThemeInfo={getThemeInfo}
                  handleRemoveNode={handleRemoveNode}
                  setThemeInitialNodes={setThemeInitialNodes}
                />
              </Grid>
            ))}
            <CreateNewNode handleCreateNode={handleCreateNode} />
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Grid container spacing={2}>
            {paymentInlineNodes?.map((nodeData: any) => (
              <Grid
                item
                sm={12}
                md={6}
                xs={12}
                lg={4}
                key={nodeData.id || nodeData.index}
                style={{ display: "flex" }}
              >
                <BannersInfoNode
                  nodeData={nodeData}
                  index={nodeData.index}
                  themeInitialNodes={themeInitialNodes}
                  getThemeInfo={getThemeInfo}
                  handleRemoveNode={handleRemoveNode}
                  setThemeInitialNodes={setThemeInitialNodes}
                />
              </Grid>
            ))}
            <CreateNewNode handleCreateNode={handleCreateNode} />
          </Grid>
        </TabPanel>
      </div>
    </>
  );
};

export default WithLoading(BannersType);
